import { ContentSpacing } from '@estee/elc-base-theme';

export const widthMarginSetup = `
    margin: 0 ${ContentSpacing.space16};
    width: calc(100% - ${ContentSpacing.space32});
`;
